import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { Sysappbuttons } from 'fccore2';
import { Fcapp } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-tlbformè¡¨åå·¥å·æ 
 * è¡¨åå·¥å·æ ç»ä»¶ã
 * è¡¨åå·¥å·æ æé®ï¼å¦ä¿å­ãä¿å­è¿åãè¿åæé®ã
 */
@Component({
    selector: 'fc-tlbform',
    template: `
    <div class='fc-tlbform'
     [ngClass] = "{'fc-hasgap':fcHasGap==='Y','fc-tlbform-small':fcSize === 'small','fc-tlbform-default':fcSize === 'default','fc-tlbform-large':fcSize === 'large'
     ,'fc-left':fcLayout==='left','fc-center':fcLayout==='center','fc-right':fcLayout==='right'}">
       <fc-button fcMode="group" [fcHasGap]="hasgap" [fcGroup]="fcButtons" [fcDisableds]="fcDisableds" (fcEvent)="event($event.eventName,$event.param)"></fc-button>
     </div>
    `,
    styles: [`
        .fc-tlbform{
            text-align: center;
            margin-top:5px;
            margin-bottom:5px;
        }
        .fc-left{
            text-align: left;
        }
        .fc-center{
            text-align: center;
        }
        .fc-right{
            text-align: right;
        }
        :host ::ng-deep .fc-hasgap .ant-btn-group > .ant-btn{
            margin-right:10px;
        }
    `]
})
export class FctlbformComponent extends FcinputComponent {
    // æ°æ®åå®¹ç¬¦åå¨æäºèå´çæ¶åæ¾ç¤ºæäºæä½æé®ï¼ä¸ç¬¦ååä¸æ¾ç¤ºï¼
    // å·ä½å®æ½æ¹æ¡ä¸ºå¨ç»ä»¶fclistdataç»ä»¶ä¸­å¢å æ°å±æ§ï¼
    // fcViewActionStrategy="[{FIELDCODE:'STATUS',FIELDVALUE:'èµ·è',BUTTONS:['listAdd','listDelete','listView',]}]"
    @Input()
    fcViewActionStrategy: string;
    viewAction: any[];
    @Input()
    fcApp: Fcapp;
    @Input()
    fcButtons: Sysappbuttons[];
    @Input()
    fcLayout: string;
    /** æ¯å¦ç¦ç¨ */
    @Input()
    fcDisableds: string;
    /** æ¯å¦æé´é */
    @Input()
    fcHasGap: string = 'Y';
    hasgap: boolean;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-tlbform');
        this.fcButtons = [];
        if (this.fcHasGap === 'Y' || undefined) {
            this.hasgap = true;
        }
    }
    _afterParentInit() {
        this.viewAction = [];
        if (this.fcViewActionStrategy) {
            try {
                this.viewAction = JSON.parse(this.fcViewActionStrategy);
            } catch {
                this.logService.error('æé®æ¾ç¤ºç­ç¥å¼å¼å¸¸ï¼è¯·åèï¼[{"FIELDCODE":"STATUS","FIELDVALUE":"èµ·è","BUTTONS":["listAdd","listDelete","listView"]}]æ ¼å¼');
            }
        }

        if (this.fcButtons === undefined || this.fcButtons.length === 0) {
            if (this.fcAppid === undefined && this.fcApp === undefined) {
                throw new Error('ç¼ºå°å·¥å·æ ç»ä»¶');
            }
            if (this.fcViewActionStrategy) {
                // å¯ç°å®çæé®
                let actions = '';
                let noactions = '';
                this.viewAction.forEach(view => {
                    const value = this.params.data[view.FIELDCODE];
                    if (value === view.FIELDVALUE
                        || (view.FIELDVALUE === 'isnull' && (value === undefined || value === null || value === '')
                            || (view.FIELDVALUE === 'isnotnull' && (value !== null && value !== undefined && value !== '')))) {
                        if (view.BUTTONS) {
                            actions += view.BUTTONS.join(',');
                        }
                    }
                    if (value === view.FIELDNOSHOWVALUE) {
                        view.NOSHOWBUTTONS.forEach(btn => {
                            noactions += btn + ',';
                        });
                    }
                });
                // ä¸å¯ç°å®çæé®
                this.fcButtons = this.fcApp.SYSAPPBUTTONS.filter(btn => {
                    // ä¸åè®¸æ¾ç¤ºç­ç¥
                    if (noactions !== '' && noactions.indexOf(btn.ACTCODE) !== -1) {
                        return false;
                    }
                    // æ¾ç¤ºç­ç¥
                    if (actions !== '') {
                        if (actions.indexOf(btn.ACTCODE) === -1) {
                            return false;
                        } else {
                            return btn.BTNTYPE === 'CARD';
                        }
                    } else {
                        return btn.BTNTYPE === 'CARD';
                    }
                });
            } else {
                this.fcButtons = this.fcApp.SYSAPPBUTTONS.filter(btn => btn.BTNTYPE === 'CARD');
            }

        }
        if (this.fcHasGap === 'N') {
            this.hasgap = false;
        }
        if (this.fcLayout === undefined) {
            this.fcLayout = ToolbarFormLayout.LEFT;
        } else if (this.fcLayout === 'left') {
            this.fcLayout = ToolbarFormLayout.LEFT;
        } else if (this.fcLayout === 'center') {
            this.fcLayout = ToolbarFormLayout.CENTER;
        } else if (this.fcLayout === 'right') {
            this.fcLayout = ToolbarFormLayout.RIGHT;
        }
    }
}

export const ToolbarFormLayout = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
}
export const ToolbarFormAction = {
    NEXT: 'next',
    PREV: 'prev',
    CARDSAVE: 'cardSave',
    CARDNEW: 'cardAdd',
    CARDSAVEBACK: 'cardSaveBack',
    CARDSAVENEW: 'cardSaveNew',
    CARDSAVECOPY: 'cardSaveCopy',
    CARDBACK: 'cardBack'
}
